import { useIntl } from 'react-intl';
import React from 'react';
import { useTitleStore } from 'src/stores/useTitleStore';
import { bankAccountMessages } from 'src/features/billingEntityBankAccounts/utils/messages';
import BillingEntityBankAccountsTable from 'src/features/billingEntityBankAccounts/components/tables/BillingEntityBankAccountsTable';

const BillingEntityBankAccountsLayout = () => {
    const { setTitle, removeTitle } = useTitleStore();
    const { formatMessage } = useIntl();

    React.useEffect(() => {
        setTitle(formatMessage(bankAccountMessages.bankAccounts));
        return removeTitle;
    }, [formatMessage, removeTitle, setTitle]);

    return <BillingEntityBankAccountsTable />;
};

export default BillingEntityBankAccountsLayout;
